<template>
  <div>
    <ActivityTable />
  </div>
</template>

<script>
import ActivityTable from "@/components/ActivityTable.vue";

export default {
  name: "ActivityPage",

  components: { ActivityTable },
};
</script>
